import React from 'react';
import { useReveal } from '../lib/useReveal';
const CHECKOUT_BASE = 'https://academiaholisticaargentina.com/cart/48929044562170:1';
const CHECKOUT_PRO = 'https://academiaholisticaargentina.com/cart/48966318555386:1';
const CHECKOUT_COMBO = 'https://academiaholisticaargentina.com/cart/48966334808314:1';
type Product = {
  emoji: string;
  title: string;
  subtitle: string;
  oldPrice: string;
  price: string;
  checkoutUrl: string;
  ctaLabel: string;
  badge?: string;
  featured?: boolean;
};
const PRODUCTS: Product[] = [{
  emoji: '🌟',
  title: 'COMBO HOLÍSTICO',
  subtitle: 'Maestría Reiki + Biodecodificación Integral',
  oldPrice: '$110.000',
  price: '$31.990',
  checkoutUrl: CHECKOUT_COMBO,
  ctaLabel: '→ QUIERO EL COMBO',
  badge: '⭐ MÁS COMPLETO',
  featured: true
}, {
  emoji: '🏆',
  title: 'MAESTRÍA + KIT PROFESIONAL',
  subtitle: '6 Tomos + 6 Bonos + Kit Pro',
  oldPrice: '$89.000',
  price: '$27.990',
  checkoutUrl: CHECKOUT_PRO,
  ctaLabel: '→ QUIERO KIT PRO',
  badge: '🎯 RECOMENDADO'
}, {
  emoji: '📘',
  title: 'MEGAPACK MAESTRÍA',
  subtitle: '6 Tomos + 6 Bonos · Niveles I, II y Maestría',
  oldPrice: '$69.000',
  price: '$19.990',
  checkoutUrl: CHECKOUT_BASE,
  ctaLabel: '→ QUIERO EL MEGAPACK'
}];
export function ClosingSection() {
  const [ref1, vis1] = useReveal();
  return <section className="relative bg-[#3d2a5f] text-white py-12 md:py-16 px-4 sm:px-6 overflow-hidden border-t border-[#4d3a6f]" data-id="element-111">
      <div ref={ref1} className={`reveal container mx-auto max-w-4xl text-center relative z-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-112">
        <p className="text-white font-serif italic text-xl sm:text-2xl md:text-3xl font-bold mb-8 md:mb-10" data-id="element-113">
          El próximo paso en tu camino puede empezar hoy.
          <br data-id="element-114" />
          <span className="text-[#c9a14d]" data-id="element-115">
            "El momento que siempre esperaste ya llegó." 🪷
          </span>
        </p>

        <div className="space-y-3 sm:space-y-4 mb-8 md:mb-10 text-left" data-id="element-116">
          {PRODUCTS.map((p, idx) => <div key={idx} className={`relative rounded-xl md:rounded-2xl overflow-hidden ${p.featured ? 'bg-[#4d3a6f] border-2 border-[#c9a14d] shadow-[0_15px_40px_rgba(0,0,0,0.3)]' : 'bg-[#4d3a6f] border border-white/10'}`} data-id="element-117">
              {p.badge && <div className="absolute top-3 right-3 z-10" data-id="element-118">
                  <span className={`text-[9px] sm:text-[10px] font-bold px-2.5 py-1 rounded-full shadow-sm whitespace-nowrap uppercase tracking-wider ${p.featured ? 'bg-gradient-to-r from-[#c9a14d] to-[#b8945a] text-white' : 'bg-white/20 text-white'}`} data-id="element-119">
                    {p.badge}
                  </span>
                </div>}

              <div className="flex flex-col sm:flex-row items-stretch" data-id="element-120">
                {/* LEFT: Info */}
                <div className="flex-1 p-4 sm:p-5 md:p-6 sm:border-r border-white/10" data-id="element-121">
                  <div className="flex items-start gap-2 pr-20 sm:pr-0" data-id="element-122">
                    <span className="text-2xl sm:text-3xl leading-none flex-shrink-0" data-id="element-123">
                      {p.emoji}
                    </span>
                    <div className="min-w-0" data-id="element-124">
                      <h3 className="text-base sm:text-lg md:text-xl font-bold text-white leading-tight" style={{
                    fontFamily: "'Playfair Display', serif"
                  }} data-id="element-125">
                        {p.title}
                      </h3>
                      <p className={`font-semibold text-[11px] sm:text-xs leading-tight mt-1 ${p.featured ? 'text-[#c9a14d]' : 'text-white/70'}`} data-id="element-126">
                        {p.subtitle}
                      </p>
                    </div>
                  </div>
                </div>

                {/* RIGHT: Price + CTA */}
                <div className="flex flex-row sm:flex-col items-center sm:items-stretch sm:justify-center gap-3 sm:gap-2 p-4 sm:p-5 md:p-6 sm:min-w-[200px] md:min-w-[230px] bg-black/10" data-id="element-127">
                  <div className="text-center flex-1 sm:flex-none" data-id="element-128">
                    <p className="text-white/50 text-[10px] sm:text-xs line-through leading-none mb-1" data-id="element-129">
                      {p.oldPrice}
                    </p>
                    <p className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-white leading-none" style={{
                  textShadow: '0 0 30px rgba(255,255,255,0.1)'
                }} data-id="element-130">
                      {p.price}
                    </p>
                    <p className="text-[10px] sm:text-xs font-bold text-white/70 mt-0.5" data-id="element-131">
                      ARS
                    </p>
                  </div>
                  <a href={p.checkoutUrl} target="_blank" rel="noopener noreferrer" className={`block px-3 py-2.5 sm:py-3 rounded-lg font-bold text-[10px] sm:text-xs tracking-wider uppercase text-center transition-all hover:-translate-y-0.5 flex-1 sm:flex-none whitespace-nowrap ${p.featured ? 'text-white bg-gradient-to-r from-[#c9a14d] to-[#b8945a] border border-[#c9a14d] shadow-[0_8px_20px_rgba(201,161,77,0.4)] hover:shadow-[0_12px_30px_rgba(201,161,77,0.5)]' : 'text-white bg-white/10 border border-white/30 hover:bg-white/20'}`} style={{
                fontFamily: "'Inter', sans-serif",
                letterSpacing: '0.03em'
              }} data-id="element-132">
                    {p.ctaLabel}
                  </a>
                </div>
              </div>
            </div>)}
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-6 text-white/60 text-[10px] sm:text-xs md:text-sm font-medium" data-id="element-133">
          <span className="flex items-center gap-1.5" data-id="element-134">🔒 Pago seguro</span>
          <span className="flex items-center gap-1.5" data-id="element-135">⚡ Acceso en 5 min</span>
          <span className="flex items-center gap-1.5" data-id="element-136">🛡️ Garantía 7 días</span>
        </div>
      </div>
    </section>;
}